var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-group",
    {
      attrs: { "no-action": "" },
      model: {
        value: _vm.isItemActive,
        callback: function($$v) {
          _vm.isItemActive = $$v
        },
        expression: "isItemActive"
      }
    },
    [
      _c(
        "v-list-tile",
        { attrs: { slot: "activator" }, slot: "activator" },
        [
          _c(
            "div",
            {
              class:
                (_vm.inspection.color ? "" : "primary ") +
                "text-xs-center mr-2",
              style: {
                height: "32px",
                width: "32px",
                "border-radius": "50%",
                padding: "5px",
                "padding-top": "5px",
                "background-color": "#" + _vm.inspection.color
              }
            },
            [
              _vm.inspection.character_problem.picto
                ? _c("v-img", {
                    style: { height: 22 + "px", width: 22 + "px" },
                    attrs: { src: _vm.inspection.character_problem.picto },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.deleteIB($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile-content",
            [
              _c(
                "v-list-tile-title",
                {
                  class: "typo-one-body",
                  staticStyle: { "font-size": "0.9em" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.inspection.character_problem.name) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.inspection.bm_ib_contractor.length ||
      (_vm.$route.meta["bm_edit"] && _vm.displayActions)
        ? _c(
            "div",
            [
              _c("v-subheader", { staticClass: "ml-5" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmContractor)))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.meta["bm_edit"] && _vm.displayActions
        ? _c(
            "v-btn",
            {
              staticClass: "ml-5",
              attrs: { flat: "" },
              on: {
                click: function($event) {
                  _vm.openBaseModal(
                    _vm.ActionModal.ContractorAdd,
                    _vm.inspection
                  )
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t(_vm.lblSetting.bmAddContractor)) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.inspection.bm_ib_contractor, function(contractor, ctIdx) {
        return _c(
          "v-layout",
          {
            key: contractor.id,
            style: _vm.$route.meta["bm_edit"] ? "cursor: pointer;" : "",
            attrs: { column: "" },
            on: {
              click: function($event) {
                _vm.$route.meta["bm_edit"]
                  ? _vm.openBaseModal(_vm.ActionModal.ContractorUp, contractor)
                  : ""
              }
            }
          },
          [
            _c(
              "v-layout",
              { attrs: { row: "", "ml-5": "" } },
              [
                _c(
                  "v-avatar",
                  {
                    staticClass: "ml-3 my-3",
                    attrs: { color: "#" + _vm.inspection.color, size: "32" }
                  },
                  [
                    contractor.contractor.entity.avatar
                      ? _c("img", {
                          attrs: {
                            src: contractor.contractor.entity.avatar.link
                          }
                        })
                      : _c("span", { staticClass: "white--text title" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.acronym(contractor.contractor.entity)
                              ) +
                              "\n              "
                          )
                        ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "ml-3 py-2", attrs: { column: "" } },
                  [
                    _c("b", {
                      domProps: {
                        textContent: _vm._s(
                          contractor.contractor.entity.firstname +
                            " " +
                            contractor.contractor.entity.lastname
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("li", [_vm._v(_vm._s(_vm.progressTxt(contractor)))]),
                    _vm._v(" "),
                    contractor.date_start_work
                      ? _c("li", [_vm._v(_vm._s(_vm.startDateTxt(contractor)))])
                      : _vm._e(),
                    _vm._v(" "),
                    contractor.date_end_work
                      ? _c("li", [_vm._v(_vm._s(_vm.endDateTxt(contractor)))])
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            ctIdx < _vm.inspection.bm_ib_contractor.length - 1
              ? _c("v-divider", { staticClass: "ml-5" })
              : _vm._e()
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("v-flex", { attrs: { "mt-2": "" } }),
      _vm._v(" "),
      _vm.comments.find(function(x) {
        return x.id === _vm.inspection.id
      }) ||
      (_vm.$route.meta["bm_edit"] && _vm.displayActions)
        ? _c(
            "div",
            [
              _c("v-subheader", { staticClass: "ml-5" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmComment)))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.comments.find(function(x) {
        return x.id === _vm.inspection.id
      })
        ? _c(
            "v-timeline",
            { staticClass: "ml-5", attrs: { dense: "", clipped: "" } },
            [
              _c(
                "v-timeline-item",
                { attrs: { "fill-dot": "", color: "primary", icon: "add" } },
                [
                  _vm.$route.meta["bm_edit"] && _vm.displayActions
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              _vm.openBaseModal(
                                _vm.ActionModal.CommentAdd,
                                _vm.inspection
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmAddComment)))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.comments.find(function(x) {
                  return x.id === _vm.inspection.id
                }).comments,
                function(cmt) {
                  return _c(
                    "v-layout",
                    { key: cmt.id, attrs: { column: "" } },
                    [
                      _c(
                        "v-slide-x-transition",
                        { attrs: { group: "" } },
                        [
                          _c(
                            "v-timeline-item",
                            {
                              key: cmt.id,
                              staticStyle: { height: "min-content" },
                              attrs: { color: "primary", small: "" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  style: _vm.$route.meta["bm_edit"]
                                    ? "cursor: pointer;"
                                    : "",
                                  on: {
                                    click: function($event) {
                                      _vm.$route.meta["bm_edit"]
                                        ? _vm.openBaseModal(
                                            _vm.ActionModal.CommentUp,
                                            cmt
                                          )
                                        : ""
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-space-between": "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        [
                                          _c("b", {
                                            attrs: { xs7: "" },
                                            domProps: {
                                              textContent: _vm._s(cmt.subject)
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-flex", {
                                            staticClass: "typo-one-body",
                                            attrs: { xs11: "" },
                                            domProps: {
                                              textContent: _vm._s(
                                                cmt.description
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.dtIsLoading
                                        ? _c("p", {
                                            staticClass: "mr-3 text-xs-right",
                                            staticStyle: {
                                              margin: "0",
                                              padding: "0",
                                              color: "#999",
                                              "font-size": "15px"
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting.bmDocumentText,
                                                  {
                                                    who: cmt.creator_name,
                                                    when: _vm.getDateDuration(
                                                      cmt.createdAt
                                                    )
                                                  }
                                                )
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { "text-xs-right": "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "my-0",
                                          attrs: { icon: "", ripple: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              _vm.$route.meta["bm_edit"]
                                                ? _vm.openBaseModal(
                                                    _vm.ActionModal.PlanSelect,
                                                    {
                                                      cmt: cmt,
                                                      inspection: _vm.inspection
                                                    }
                                                  )
                                                : ""
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("room")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", "justify-start": "" } },
                                [
                                  cmt.ticket
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "white--text ml-0 mr-2",
                                          staticStyle: { cursor: "pointer" },
                                          attrs: {
                                            color: _vm.getStateTicketColor(cmt),
                                            label: "",
                                            small: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.goToTicket(cmt.ticket)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getTicketRef(cmt.ticket)
                                            ) + "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  cmt.state === "close"
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "white--text mx-0",
                                          attrs: {
                                            color: "red",
                                            label: "",
                                            small: ""
                                          }
                                        },
                                        [_vm._v("Clos\n            ")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "grey--text darken-3 typo-one-subtitle"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.bmHint) +
                                          " " +
                                          cmt.hint_comment +
                                          " (" +
                                          cmt.hint_comment +
                                          "a, " +
                                          cmt.hint_comment +
                                          "b...)"
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          cmt.medias.length
                            ? _c(
                                "v-timeline-item",
                                {
                                  key: "media" + cmt.id,
                                  staticStyle: { height: "min-content" },
                                  attrs: { "hide-dot": "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "pb-3",
                                      staticStyle: {
                                        "overflow-x": "auto",
                                        "flex-wrap": "nowrap"
                                      },
                                      attrs: { row: "", "justify-start": "" }
                                    },
                                    [
                                      _vm._l(cmt.medias, function(media, idx) {
                                        return _c(
                                          "v-flex",
                                          {
                                            key: media.id,
                                            staticClass: "mr-3 mt-2"
                                          },
                                          [
                                            _c(
                                              "v-badge",
                                              {
                                                attrs: {
                                                  overlap: "",
                                                  color: "primary"
                                                },
                                                model: {
                                                  value:
                                                    _vm.$route.meta[
                                                      "bm_edit"
                                                    ] && _vm.displayActions,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.$route,
                                                      "meta['bm_edit'] && displayActions",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "$route.meta['bm_edit'] && displayActions"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      slot: "badge",
                                                      dark: "",
                                                      small: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.displayModalDeleteImage(
                                                          media,
                                                          cmt
                                                        )
                                                      }
                                                    },
                                                    slot: "badge"
                                                  },
                                                  [_vm._v("close")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-layout",
                                                  {
                                                    attrs: {
                                                      column: "",
                                                      "align-center": ""
                                                    }
                                                  },
                                                  [
                                                    media.media.type === "image"
                                                      ? _c("img", {
                                                          directives: [
                                                            {
                                                              name: "img",
                                                              rawName: "v-img",
                                                              value: {
                                                                title:
                                                                  media.media
                                                                    .name,
                                                                src:
                                                                  media.media
                                                                    .link
                                                              },
                                                              expression:
                                                                "{title: media.media.name, src:media.media.link}"
                                                            }
                                                          ],
                                                          staticClass: "mb-2",
                                                          style: {
                                                            "border-radius":
                                                              "5px",
                                                            height: "calc(25vh)"
                                                          },
                                                          attrs: {
                                                            src:
                                                              media.media.link,
                                                            alt:
                                                              media.media.name
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    media.media.type !== "image"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ma-2 mt-5"
                                                          },
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  "align-center":
                                                                    "",
                                                                  "justify-center":
                                                                    "",
                                                                  row: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticStyle: {
                                                                      "text-decoration":
                                                                        "none"
                                                                    },
                                                                    attrs: {
                                                                      href:
                                                                        media
                                                                          .media
                                                                          .link,
                                                                      target:
                                                                        "_blank"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "50",
                                                                          color:
                                                                            "primary"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "description"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    media.media.type !== "image"
                                                      ? _c("div", {
                                                          staticClass:
                                                            "twoLineEllipsis typo-one-title",
                                                          style: {
                                                            "text-align":
                                                              "center",
                                                            lineHeight: "16px"
                                                          },
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.nameFileDoc(
                                                                media.media.name
                                                              )
                                                            )
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    media.media.type !== "image"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "oneLineEllipsis typo-one-subtitle",
                                                            staticStyle: {
                                                              width:
                                                                "calc(25vh)",
                                                              "text-align":
                                                                "center"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  _vm.typeDocument(
                                                                    media.media
                                                                      .name
                                                                  )
                                                                ) +
                                                                "\n                "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("v-flex", [
                                        _c("div", {
                                          staticStyle: {
                                            width: "6px",
                                            height: "8px",
                                            "background-color": "transparent"
                                          }
                                        })
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              )
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba0cf954", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba0cf954","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-ib-item/template.html
// module id = null
// module chunks = 